<template>
    <div>
      <Pos_invoice_receipt/>
    </div>
  </template>
  
  <script>
  import Pos_invoice_receipt from "@/components/adminArin/pos_system/pos/Pos_invoice_Receipt";
  export default {
    name: "PosInvoiceReceipt",
    components: {
      Pos_invoice_receipt
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  